import ActivityBody from "./ActivityBody";
import ActivityBodyInfo from "./activity-body-info";

export default ActivityBody;

export { ActivityBodyInfo };
